import { Select, SelectProps } from 'antd';
import React, { memo } from 'react';

import { L } from '@lib';

const { Option } = Select;

export const TransmissionSelect: React.FC<SelectProps> = memo((props) => (
  <Select
    allowClear
    placeholder={L('Select gear type')}
    style={{ width: '100%' }}
    {...props}
  >
    <Option value="Manual">{L('Manual')}</Option>
    <Option value="Automatic">{L('Automatic')}</Option>
    <Option value="Semi-Automatic">{L('Semi-Automatic')}</Option>
    <Option value="CVT">{L('CVT')}</Option>
  </Select>
));
